@if (loading()) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
} @else {
  <div class="my-4">
    @if (isOldInvoice()) {
      <aux-invoice-items-tab [invoice]="invoice()" [items]="invoice().ocr_line_items || []" />
    } @else {
      <div class="my-4 flex flex-row-reverse">
        <aux-button
          variant="secondary"
          label="Export"
          icon="FileExport"
          data-pendo-id="invoice-items-via-pdf-export-button"
          [disabled]="gridData().length === 0 || editMode()"
          (click)="getDynamicExcelParams()"
        />

        <div class="flex">
          <aux-button
            variant="secondary"
            label="Map to Budget"
            class="mr-2"
            data-pendo-id="map-to-budget-pdf-items-button"
            [template]="mapToBudgetTooltip().length > 1 ? errorArrayTooltip : undefined"
            [auxTooltip]="mapToBudgetTooltip().length === 1 ? mapToBudgetTooltip()[0] : ''"
            [disabled]="!!mapToBudgetTooltip().length"
            (clickEmit)="openMapActivitiesModal()"
          ></aux-button>

          <ng-template #errorArrayTooltip>
            <aux-errors-tooltip [errors]="mapToBudgetTooltip()" />
          </ng-template>

          @if (editMode()) {
            <aux-button
              variant="secondary"
              label="Cancel"
              icon="X"
              class="mr-2"
              (click)="onCancel()"
            />

            <aux-button
              variant="success"
              label="Save"
              icon="Check"
              class="mr-2"
              data-pendo-id="invoice-items-via-pdf-save-button"
              [disabled]="!hasChanges()"
              [onClick]="onSave"
            />
          } @else {
            <aux-button
              variant="secondary"
              label="Edit"
              icon="Pencil"
              class="mr-2"
              data-pendo-id="invoice-items-via-pdf-edit-button"
              [disabled]="isEditBtnDisabled()"
              [auxTooltip]="getEditBtnTooltip()"
              (click)="editMode.set(true)"
            />
          }
        </div>
      </div>

      @if (gridData().length > 0) {
        <ag-grid-angular
          class="ag-theme-aux tabular-nums"
          domLayout="autoHeight"
          [rowData]="gridData()"
          [gridOptions]="gridOptions()"
          [enableFillHandle]="editMode()"
          (gridReady)="gridAPI.set($event.api)"
          (firstDataRendered)="autosize()"
          (cellValueChanged)="onCellValueChanged($event)"
          auxStickyGrid
        />
      } @else {
        <aux-invoice-items-no-rows [invoice]="invoice()" />
      }
    }
  </div>
}
